import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

export interface Device {
  name: string;
  public: boolean;
  access_token: string;
  exp: number;
}

export const getDevice = () => {
  try {
    const eregDeviceToken = Cookies.get('ereg-device-token');
    if (eregDeviceToken) {
      return jwtDecode(eregDeviceToken) as Device;
    }
    return null;
  } catch (_e) {
    return null;
  }
};
